import BaseController from "src/controller/BaseController.js";
import ApiUrls from "src/routes/api";
import RestApiClient from "src/utils/RestApiClient";

const api = new RestApiClient();

class Schedule extends BaseController {
  async getMyClasses(query = "") {
    return new Promise((resolve, reject) => {
      api
        .get(ApiUrls.schedule.myClasses + query)
        .then((res) => {
          if (res.result) {
            resolve(res.data ?? []);
          } else {
            this.handleError(res, reject);
          }
        })
        .catch((err) => reject(err));
    });
  }

  async getMyClassesStudent(query = "") {
    return new Promise((resolve, reject) => {
      api
        .get(ApiUrls.schedule.myClassesStudent + query)
        .then((res) => {
          if (res.result) {
            resolve(res.data ?? []);
          } else {
            this.handleError(res, reject);
          }
        })
        .catch((err) => reject(err));
    });
  }

  async getAdminDayView(date, filters = {}) {
    return new Promise((resolve, reject) => {
      const url = ApiUrls.schedule.adminDayView(date, filters);
      api
        .get(url)
        .then((res) => {
          if (res.result) {
            resolve(res.data ?? []);
          } else {
            this.handleError(res, reject);
          }
        })
        .catch((err) => reject(err));
    });
  }

  async getAdminRangeReport({ start_date, end_date, teacher_id } = {}) {
    return new Promise((resolve, reject) => {
      const url = ApiUrls.schedule.adminRangeReport({
        start_date,
        end_date,
        teacher_id,
      });
      api
        .get(url)
        .then((res) => {
          if (res.result) {
            resolve(res.data ?? null);
          } else {
            this.handleError(res, reject);
          }
        })
        .catch((err) => reject(err));
    });
  }

  async updateStatus(id, { status, occurrence_id, reason }) {
    return new Promise((resolve, reject) => {
      if (!id) reject({ message: "Class id is required" });
      const body = { status, occurrence_id };
      if (status === "canceled" && reason?.trim()) {
        body.reason = reason.trim();
      }
      api
        .put(ApiUrls.schedule.updateStatus(id), body)
        .then((res) => {
          if (res.result) {
            resolve(res.data ?? res);
          } else {
            this.handleError(res, reject);
          }
        })
        .catch((err) => reject(err));
    });
  }

  async createEvent(eventData) {
    return new Promise((resolve, reject) => {
      api
        .post(ApiUrls.schedule.createEvent, eventData)
        .then((res) => {
          if (res.result) {
            resolve(res.data ?? res);
          } else {
            this.handleError(res, reject);
          }
        })
        .catch((err) => reject(err));
    });
  }

  async getStatusHistory(id) {
    return new Promise((resolve, reject) => {
      if (!id) reject({ message: "Class id is required" });
      api
        .get(ApiUrls.schedule.statusHistory(id))
        .then((res) => {
          if (res.result) {
            resolve(res.data ?? []);
          } else {
            this.handleError(res, reject);
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export default new Schedule();
